import React, { memo } from 'react';
import { View, TouchableOpacity, Clipboard } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space, IconCopy } from '@redlink/components/atoms';
import { useAlert } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';

export const CopyUrl = memo(({ url }) => {
  const { styles, colors } = useStyle();
  const alert = useAlert();
  const { dictionary } = useLocale();

  return (
    <TouchableOpacity
      activeOpacity={0.7}
      onPress={() => {
        Clipboard.setString(url);
        alert.show(dictionary.copiedInClipboard, { type: 'info' });
      }}
      style={styles.container}
    >
      <View style={styles.leftContainer}>
        <Text en style={styles.urlText}>{url}</Text>
      </View>
      <Space size={8} />
      <IconCopy color={colors.black} />
    </TouchableOpacity>
  );
});

const useStyle = createUseStyle(({ colors, ltrFlexDirection }) => ({
  container: {
    padding: 8,
    borderWidth: 1,
    borderRadius: 8,
    alignItems: 'center',
    borderColor: colors.gray7,
    flexDirection: ltrFlexDirection,
    justifyContent: 'space-between',
  },
  leftContainer: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },
  iconButton: {
    width: 32,
    height: 32,
  },
  urlText: {
    fontSize: 14,
    lineHeight: 17,
    fontWeight: '500',
    color: colors.black,
  },
}));
